(function () {
	'use strict';

	angular
		.module('ProjectModule')
		.controller('ProjectListController', ProjectListController);

	ProjectListController.$inject = [
		'$log',
		'$scope',
		'$rootScope',
		'ProjectService',
		'$state',
		'PermissionService',
		'gettextCatalog',
		'toaster',
		'$window',
		'$timeout',
		'AppSelectorService',
	];

	function ProjectListController(
		$log,
		$scope,
		$rootScope,
		ProjectService,
		$state,
		PermissionService,
		gettextCatalog,
		toaster,
		$window,
		$timeout,
		AppSelectorService
	) {
		function readSelectedProject() {
			$scope.selectedProjectId = AppSelectorService.getSelectedProjectId();
		}

		readSelectedProject();

		$scope.$on('update:project:selection', readSelectedProject);

		$scope.deletePopupOptions = {
			width: 700,
			height: 270,
			contentTemplate: 'deletePopup',
			showTitle: true,
			position: { my: 'top', at: 'top', of: window, offset: '0 30' },
			dragEnabled: false,
			hideOnOutsideClick: false,
			bindingOptions: {
				visible: 'visibleDeletePopup',
			},
			title: 'Confirmation de la suppression',
		};

		$scope.hasMemberRole = $rootScope.hasMemberRole;
		$scope.hasProjectRole = $rootScope.hasProjectRole;

		$scope.sendMailData = {
			projectId: '',
			member: undefined,
		};

		// Fed from the grouping tags actually carried by the loaded projects; the
		// filter bar takes a flat list of codes (Array<string>). UNTAGGED_CODE is
		// always offered so "no grouping tag" is pickable even when no project
		// carries one, and the bar renders it through groupingTagLabels.
		$scope.availableGroupingTags = [];
		$scope.groupingTagLabels = {};

		var NO_TAGS = [];

		var PROJECTS_VIEW_MODE_KEY = 'dc.projects.viewMode';
		var PROJECTS_DISPLAY_MODE_KEY = 'dc.projects.displayMode';
		// The dock's own two, owned here with the other two: one place decides
		// what the page comes back as.
		var DOCK_TAGS_KEY = 'dc.projects.groupingTags';
		var DOCK_MODE_KEY = 'dc.projects.groupingMode';
		// Must stay in sync with UNTAGGED_CODE in project-tag-folders.component.js
		var UNTAGGED_CODE = '__dc_untagged__';

		var VIEW_MODES = ['cards', 'folders', 'groups'];
		var DISPLAY_MODES = ['flat', 'tag'];

		// The single section the flat layout renders everything into. Any code that
		// cannot collide with a grouping tag code would do.
		var ALL_SECTION_CODE = '__dc_all__';

		var storedViewMode = $window.localStorage.getItem(PROJECTS_VIEW_MODE_KEY);
		$scope.viewMode =
			VIEW_MODES.indexOf(storedViewMode) > -1 ? storedViewMode : 'cards';
		$scope.openedTag = undefined;

		// How the cards are laid out: one flat grid, or one lane per grouping tag.
		// Independent of the dock, and of whether the dock is on screen at all.
		var storedDisplayMode = $window.localStorage.getItem(
			PROJECTS_DISPLAY_MODE_KEY
		);
		$scope.displayMode =
			DISPLAY_MODES.indexOf(storedDisplayMode) > -1
				? storedDisplayMode
				: 'flat';
		// What the dock currently has selected, in the dock's own order. The dock
		// owns the selection; the page only reads it to cut the lanes.
		$scope.dockSelection = [];

		// What the dock is handed. Read from storage once, then kept current from
		// the dock's reports: the dock sits behind an ng-if and is rebuilt every
		// time the view leaves the groups layout, so this has to hold the live
		// selection, not the one stored at page load.
		//
		// undefined is a first visit, which the dock answers by selecting
		// everything. An empty array is a deselect-all and comes back as one.
		// Anything unreadable reads as never stored.
		$scope.dockSelectionCodes = readDockSelection();
		$scope.dockMode = readDockMode();

		function readDockSelection() {
			var raw = $window.localStorage.getItem(DOCK_TAGS_KEY);
			if (raw === null) {
				return undefined;
			}
			var codes;
			try {
				codes = JSON.parse(raw);
			} catch (error) {
				return undefined;
			}
			if (!_.isArray(codes)) {
				return undefined;
			}
			return _.filter(codes, function (code) {
				return _.isString(code);
			});
		}

		function readDockMode() {
			return $window.localStorage.getItem(DOCK_MODE_KEY) === 'exclusive'
				? 'exclusive'
				: 'union';
		}

		// The only writer. Called from the dock's reports of user actions, never
		// from an untouched default, so a tag created later is not deselected for
		// everyone who never chose that.
		function persistDockState(codes, mode) {
			$window.localStorage.setItem(
				DOCK_TAGS_KEY,
				JSON.stringify(codes ? codes : [])
			);
			$window.localStorage.setItem(
				DOCK_MODE_KEY,
				mode === 'exclusive' ? 'exclusive' : 'union'
			);
		}

		// The Angular filter bar is the only source of the search term and of the
		// selected grouping tags.
		$scope.searchText = '';
		$scope.selectedGroupingTags = [];
		// Mirrors INITIAL_FILTER in catalog-filter.service.ts.
		$scope.sortBy = 'date-desc';
		$scope.favoritesOnly = false;
		// When false the filters above stay configured but are not applied.
		$scope.filtersEnabled = true;
		// What the folder view actually groups by. Kept separate from the
		// configured selection so suspending empties it without losing it, and
		// kept as one stable array so the '<' binding does not re-fire per digest.
		$scope.appliedGroupingTags = [];

		// Single entry point for everything the Angular filter bar publishes.
		$scope.onFilterState = function (state) {
			if (!state) {
				return;
			}
			setViewMode(state.viewMode);
			setDisplayMode(state.displayMode);
			// One filterProjects() pass for both, so a state carrying a new search
			// term and a new tag selection does not filter twice.
			const searchChanged = setSearchText(state.search);
			const tagsChanged = setGroupingTags(state.keywords);
			const sortChanged = setSortBy(state.sortBy);
			const favoritesChanged = setFavoritesOnly(state.favoritesOnly);
			const enabledChanged = setFiltersEnabled(state.filtersEnabled);
			if (
				searchChanged ||
				tagsChanged ||
				sortChanged ||
				favoritesChanged ||
				enabledChanged
			) {
				$scope.filterProjects();
			}
		};

		function setSearchText(search) {
			const next = search ? search : '';
			if (next === $scope.searchText) {
				return false;
			}
			$scope.searchText = next;
			return true;
		}

		function setFavoritesOnly(favoritesOnly) {
			const next = !!favoritesOnly;
			if (next === $scope.favoritesOnly) {
				return false;
			}
			$scope.favoritesOnly = next;
			return true;
		}

		function setFiltersEnabled(filtersEnabled) {
			// Absent means enabled: an older state object must not silently
			// suspend everything.
			const next = filtersEnabled !== false;
			if (next === $scope.filtersEnabled) {
				return false;
			}
			$scope.filtersEnabled = next;
			return true;
		}

		function setSortBy(sortBy) {
			const next = sortBy ? sortBy : 'date-desc';
			if (next === $scope.sortBy) {
				return false;
			}
			$scope.sortBy = next;
			return true;
		}

		// The bar publishes its selection as a Set<string> of grouping tag codes;
		// it crosses the custom-element boundary as a live object, not JSON.
		function setGroupingTags(keywords) {
			const next = keywords ? Array.from(keywords) : [];
			const current = $scope.selectedGroupingTags;
			if (
				next.length === current.length &&
				!_.difference(next, current).length
			) {
				return false;
			}
			$scope.selectedGroupingTags = next;
			return true;
		}

		// filteringState fires on every filter change (search, keywords, sort), so
		// an unchanged mode bails out: openedTag must survive a keystroke.
		function setViewMode(mode) {
			if (VIEW_MODES.indexOf(mode) === -1) {
				return;
			}
			if (mode === $scope.viewMode) {
				return;
			}
			const docked = $scope.viewMode === 'groups' || mode === 'groups';
			$scope.viewMode = mode;
			// Leaving the groups view drops what the dock was narrowing to.
			if (mode !== 'groups') {
				$scope.dockProjects = [];
				$scope.dockSelection = [];
			} else {
				// Entering it, the dock has not reported yet. Opening on
				// everything rather than on nothing keeps the gap before its
				// first report from reading as an empty page.
				$scope.dockProjects = $scope.filteredProjects
					? $scope.filteredProjects
					: [];
			}
			if (docked) {
				announceDockTransition();
			}
			$scope.closeTagFolder();
			// Entering the groups view, the dock mounts in this same digest and
			// its report rebuilds everything before anything is painted.
			if (mode !== 'groups') {
				applyState();
			}
			$window.localStorage.setItem(PROJECTS_VIEW_MODE_KEY, mode);
			// The selection filters projects in one view and folders in the other,
			// so the project list has to be rebuilt on the way across.
			if ($scope.selectedGroupingTags.length) {
				$scope.filterProjects();
			}
		}

		// The dock slides in and out, and the grid beside it takes back the room a
		// frame at a time. Every one of those frames resizes the lanes, and a lane
		// measures each of its cards when it is resized - so the lanes are told to
		// stop measuring until it has landed, then to measure once. Kept to a
		// timer rather than transitionend: the transition belongs to an element
		// this controller does not own, and may not run at all under
		// prefers-reduced-motion.
		// Covers the longer of the two sequences in project.css: 200ms to widen
		// plus 150ms to reveal, with room to spare.
		var DOCK_TRANSITION_MS = 380;
		var dockTransition;

		function announceDockTransition() {
			$timeout.cancel(dockTransition);
			$rootScope.$broadcast('pj:dock-transition', true);
			dockTransition = $timeout(function () {
				$rootScope.$broadcast('pj:dock-transition', false);
			}, DOCK_TRANSITION_MS, false);
		}

		function setDisplayMode(mode) {
			if (DISPLAY_MODES.indexOf(mode) === -1) {
				return;
			}
			if (mode === $scope.displayMode) {
				return;
			}
			$scope.displayMode = mode;
			$window.localStorage.setItem(PROJECTS_DISPLAY_MODE_KEY, mode);
			refreshRenderSections();
		}

		// The dock reports what the user did; the page is what writes it down.
		$scope.onDockChange = function (codes, mode) {
			$scope.dockSelectionCodes = codes ? codes : [];
			$scope.dockMode = mode === 'exclusive' ? 'exclusive' : 'union';
			persistDockState($scope.dockSelectionCodes, $scope.dockMode);
		};

		$scope.openedTagProjects = [];

		// What the dock's tag selection leaves of filteredProjects, and which
		// lanes to cut it into. The dock owns what a selection means; the page
		// only renders the result.
		$scope.dockProjects = [];

		$scope.onDockResult = function (projects, tags) {
			$scope.dockProjects = projects ? projects : [];
			$scope.dockSelection = tags ? tags : [];
			applyState();
		};

		// Everything the current mode has to show, in one flat array: what the
		// sections are cut from, and what the counts and the empty state read.
		$scope.displayedProjects = [];

		// One pass per state change: the flat list, the sections cut from it and
		// the counts read off it are one derivation, not three.
		function applyState() {
			setDisplayedProjects();
			refreshRenderSections();
			refreshResultCounts();
		}

		function setDisplayedProjects() {
			if ($scope.openedTag) {
				$scope.displayedProjects = $scope.openedTagProjects;
				return;
			}
			if ($scope.viewMode === 'groups') {
				$scope.displayedProjects = $scope.dockProjects;
				return;
			}
			$scope.displayedProjects = $scope.filteredProjects
				? $scope.filteredProjects
				: [];
		}

		// The sections the card grid repeats over. Every mode renders sections;
		// the flat layout just renders a single headerless one, so there is one
		// grid and one copy of the card markup rather than two.
		$scope.renderSections = [];

		// How the cards are laid out, and nothing else. The dock is a selector,
		// not a precondition: lanes render whether or not it is on screen.
		function tagLayoutActive() {
			return $scope.displayMode === 'tag';
		}

		// Every grouping tag the given projects carry, sorted, plus the untagged
		// bucket when any of them has none. Same shape as the dock's buildTags -
		// the lanes read the same fields either way - and the source of the lanes
		// whenever the dock is not on screen to supply a selection. The dock being
		// off is the dock not filtering at all, so nothing is narrowed here: the
		// lanes are the whole catalogue, cut up.
		function laneTags(projects) {
			const byCode = {};
			let untagged = false;
			_.each(projects, function (project) {
				if (!project.grouping_tags || !project.grouping_tags[0]) {
					untagged = true;
					return;
				}
				_.each(project.grouping_tags, function (tag) {
					if (!tag || !tag.code || byCode[tag.code]) {
						return;
					}
					// First occurrence wins for the colour, as in the dock.
					byCode[tag.code] = {
						code: tag.code,
						color: tag.color,
						labelColor: tagLabelColor(tag.color),
					};
				});
			});
			const tags = _.map(_.keys(byCode).sort(), function (code) {
				return byCode[code];
			});
			if (untagged) {
				tags.push({
					code: UNTAGGED_CODE,
					color: undefined,
					labelColor: undefined,
				});
			}
			return tags;
		}

		// One section per lane tag. With the dock on screen that is its selection,
		// in its own order, so the lanes read the way the chips do; with the dock
		// off it is the whole catalogue. A project carrying two of them renders
		// under both.
		function buildTagSections() {
			const projects = $scope.displayedProjects
				? $scope.displayedProjects
				: [];
			const tags =
				$scope.viewMode === 'groups'
					? $scope.dockSelection
					: laneTags(projects);
			return _.map(tags, function (tag) {
				return {
					code: tag.code,
					tag: tag,
					projects: projectsForTag(tag, projects),
				};
			});
		}

		function refreshRenderSections() {
			$scope.renderSections = tagLayoutActive()
				? buildTagSections()
				: [
						{
							code: ALL_SECTION_CODE,
							tag: undefined,
							projects: $scope.displayedProjects,
						},
				  ];
		}

		$scope.openTagFolder = function (tag) {
			$scope.openedTag = tag;
			refreshOpenedTagProjects();
		};

		// Folder tiles navigate straight into a project: administrators land on the
		// project settings, everyone else on the project home.
		$scope.openProject = function (project) {
			if (!project) {
				return;
			}
			// if (project.admin) {
			// 	$state.go('projects-edit', { projectId: project.id });
			// 	return;
			// }
			$rootScope.$broadcast('update:menu:selection', true);
			$state.go('gd-home', { projectId: project.id });
		};

		$scope.closeTagFolder = function () {
			$scope.openedTag = undefined;
			$scope.openedTagProjects = [];
			refreshResultCounts();
		};

		function projectsForTag(tag, projects) {
			return _.filter(projects, function (project) {
				if (tag.code === UNTAGGED_CODE) {
					return !project.grouping_tags || !project.grouping_tags[0];
				}
				return !!_.find(project.grouping_tags, function (projectTag) {
					return projectTag.code === tag.code;
				});
			});
		}

		// Distinct grouping tag codes across every loaded project, sorted. lodash
		// 3.10 has no _.uniqBy, hence the map/keys pass.
		function refreshAvailableGroupingTags() {
			const byCode = {};
			_.each($scope.projects, function (project) {
				_.each(project.grouping_tags, function (tag) {
					if (tag && tag.code) {
						byCode[tag.code] = true;
					}
				});
			});
			$scope.availableGroupingTags = _.keys(byCode).sort();
			$scope.availableGroupingTags.push(UNTAGGED_CODE);
			$scope.groupingTagLabels = {};
			$scope.groupingTagLabels[UNTAGGED_CODE] =
				gettextCatalog.getString('project.tag.none');
		}

		// What the filter bar's result line counts: folders while the folder view
		// lists them, projects in the card view and inside an opened folder.
		$scope.resultKind = 'projects';
		$scope.resultCount = 0;
		$scope.totalCount = 0;

		// Distinct grouping tag codes, plus the untagged default - mirrors what
		// buildFolders() does in project-tag-folders.component.js.
		function folderCodes(projects) {
			const byCode = {};
			let untagged = false;
			_.each(projects, function (project) {
				if (!project.grouping_tags || !project.grouping_tags[0]) {
					untagged = true;
					return;
				}
				_.each(project.grouping_tags, function (tag) {
					if (tag && tag.code) {
						byCode[tag.code] = true;
					}
				});
			});
			const codes = _.keys(byCode);
			if (untagged) {
				codes.push(UNTAGGED_CODE);
			}
			return codes;
		}

		// Same rule as selectFolders() in project-tag-folders.component.js.
		function countVisibleFolders(projects) {
			const codes = folderCodes(projects);
			if (!$scope.appliedGroupingTags.length) {
				return codes.length;
			}
			return _.intersection(codes, $scope.appliedGroupingTags).length;
		}

		function refreshResultCounts() {
			// The dock narrows the list further than filterProjects() did, so the
			// count comes from what it handed back - over the whole catalogue.
			if ($scope.viewMode === 'groups') {
				$scope.resultKind = 'projects';
				$scope.resultCount = $scope.dockProjects.length;
				$scope.totalCount = $scope.projects ? $scope.projects.length : 0;
				return;
			}

			if ($scope.viewMode === 'folders' && !$scope.openedTag) {
				$scope.resultKind = 'folders';
				$scope.resultCount = countVisibleFolders($scope.filteredProjects);
				$scope.totalCount = folderCodes($scope.projects).length;
				return;
			}

			$scope.resultKind = 'projects';
			if ($scope.openedTag) {
				// Inside a folder the denominator is that folder, not the catalogue.
				$scope.resultCount = $scope.openedTagProjects.length;
				$scope.totalCount = projectsForTag(
					$scope.openedTag,
					$scope.projects
				).length;
				return;
			}
			$scope.resultCount = $scope.filteredProjects
				? $scope.filteredProjects.length
				: 0;
			$scope.totalCount = $scope.projects ? $scope.projects.length : 0;
		}

		// Kept as a plain array rather than a function called from ng-repeat: a fresh
		// array on every digest makes ng-repeat thrash.
		function refreshOpenedTagProjects() {
			$scope.openedTagProjects = $scope.openedTag
				? projectsForTag($scope.openedTag, $scope.filteredProjects)
				: [];
			applyState();
		}

		var loadProjects = function () {
			ProjectService.getProjects().then(function (response) {
				const data = response.data;
				_.each(data, function (item) {
					item.inactive =
						item.expired || !item.metadata.actif || item.premature;
				});
				$scope.projects = data;
				for (let p in $scope.projects) {
					$scope.projects[p].expiration_date = $scope.projects[p]
						.expiration_date
						? moment($scope.projects[p].expiration_date)
						: '';
					$scope.projects[p].effectiveness_date = $scope.projects[p]
						.effectiveness_date
						? moment($scope.projects[p].effectiveness_date)
						: '';
				}
				refreshAvailableGroupingTags();
				// Sorts as well as filters, and filters can already be in place
				// when the payload lands.
				$scope.filterProjects();
				ProjectService.getProjectMembersCount().then(function (response) {
					const data = response.data;
					for (let p in $scope.projects) {
						$scope.projects[p].member_count = data[$scope.projects[p].id]
							? data[$scope.projects[p].id]
							: 0;
					}
				});
				ProjectService.getProjectContextsCount().then(function (response) {
					const data = response.data;
					for (let p in $scope.projects) {
						$scope.projects[p].context_count = data[$scope.projects[p].id]
							? data[$scope.projects[p].id]
							: 0;
					}
				});
				ProjectService.getProjectContextAvailabilities().then(function (
					response
				) {
					const data = response.data;
					for (let p in $scope.projects) {
						$scope.projects[p].unavailable_contexts =
							data[$scope.projects[p].id] == false;
					}
				});
				ProjectService.getProjectLastAccess().then(function (response) {
					const data = response.data;
					for (let p in $scope.projects) {
						const access = data[$scope.projects[p].id];
						$scope.projects[p].last_access_by = access ? access.v2 : '';
						// The timestamp as received: the cards format it, and read it
						// back from a string formatted here would mean parsing it again.
						$scope.projects[p].last_access_date = access ? access.v1 : '';
					}
				});
			});
		};
		loadProjects();

		$scope.filterProjects = function () {
			$scope.appliedGroupingTags = $scope.filtersEnabled
				? $scope.selectedGroupingTags
				: NO_TAGS;
			$scope.filteredProjects = sortProjects(
				_.filter($scope.projects, function (item) {
					// Suspended: the filters keep their values, none are applied.
					// Sorting is not a filter and keeps running.
					if (!$scope.filtersEnabled) {
						return true;
					}
					return (
						matchesFavorite(item) &&
						matchesSearch(item) &&
						matchesGroupingTags(item)
					);
				})
			);
			refreshOpenedTagProjects();
		};

		function matchesFavorite(item) {
			return !$scope.favoritesOnly || !!item.favorite_project;
		}

		// metadata.update_date is whatever the backend sends - epoch, ISO string or
		// a formatted one - so let moment parse it, the way $filter('date') does
		// elsewhere. Unparseable or absent sorts last.
		function updatedAt(project) {
			const value = project.metadata.update_date;
			if (!value) {
				return 0;
			}
			const time = moment(value).valueOf();
			return isNaN(time) ? 0 : time;
		}

		function projectLabel(project) {
			return project.metadata.label ? project.metadata.label.toLowerCase() : '';
		}

		function applySortCriterion(projects, sortBy) {
			if (sortBy === 'date-asc') {
				return _.sortBy(projects, updatedAt);
			}
			if (sortBy === 'title-asc') {
				return _.sortBy(projects, projectLabel);
			}
			if (sortBy === 'title-desc') {
				return _.sortBy(projects, projectLabel).reverse();
			}
			// date-desc, the default. Negated key rather than .reverse() so
			// projects sharing a timestamp keep a stable order.
			return _.sortBy(projects, function (project) {
				return -updatedAt(project);
			});
		}

		// Ordering rules, strongest last: _.sortBy is stable, so each pass only
		// reshuffles what the previous ones left tied. Favourites first, then
		// available before expired or otherwise inactive, then the bar's own
		// criterion - which is why the criterion is applied first.
		function sortProjects(projects) {
			let sorted = applySortCriterion(projects, $scope.sortBy);
			// Coerced: _.sortBy's property shorthand sorts an undefined flag after
			// a true one, which would push untouched projects below expired ones.
			sorted = _.sortBy(sorted, function (project) {
				return !!project.expired;
			});
			sorted = _.sortBy(sorted, function (project) {
				return !!project.inactive;
			});
			return _.sortBy(sorted, function (project) {
				return !project.favorite_project;
			});
		}

		// A project passes when it carries at least one of the selected grouping
		// tags - the usual facet semantics, not "carries them all".
		// The folder view is the exception: there a selection picks folders, so the
		// project list stays whatever the search left, and project-tag-folders
		// narrows the folders it builds from it.
		function matchesGroupingTags(item) {
			if (
				$scope.viewMode === 'folders' ||
				!$scope.selectedGroupingTags.length
			) {
				return true;
			}
			if (
				$scope.selectedGroupingTags.indexOf(UNTAGGED_CODE) > -1 &&
				(!item.grouping_tags || !item.grouping_tags[0])
			) {
				return true;
			}
			return !!_.find(item.grouping_tags, function (groupingTag) {
				return (
					groupingTag.code &&
					$scope.selectedGroupingTags.indexOf(groupingTag.code) > -1
				);
			});
		}

		// Case- and accent-insensitive: "donnees" has to find "Donnees" and
		// "Donnees" alike. NFD splits an accented letter into letter + combining
		// mark, and the range strips the marks.
		function normalize(value) {
			if (!value) {
				return '';
			}
			return String(value)
				.normalize('NFD')
				.replace(/[\u0300-\u036f]/g, '')
				.toLowerCase();
		}

		function containsTerm(value, term) {
			return normalize(value).indexOf(term) > -1;
		}

		function anyTagContains(tags, term) {
			return !!_.find(tags, function (tag) {
				return tag && containsTerm(tag.code, term);
			});
		}

		function matchesSearch(item) {
			if (!$scope.searchText) {
				return true;
			}
			// Normalized once per project rather than once per field comparison.
			const term = normalize($scope.searchText);
			return (
				containsTerm(item.metadata.label, term) ||
				containsTerm(item.metadata.description, term) ||
				anyTagContains(item.metadata.tags, term)
			);
		}

		$scope.newProject = function () {
			$state.go('projects-new', {});
		};

		$scope.importProject = function () {
			ProjectService.isAnyExecutionRunning().then(function (response) {
				if (!response.data) {
					// L'import simple reutilise le meme modal : sans cette remise a
					// zero, une ouverture precedente en "nouvelle version" laisse sa
					// cible et le modal reste en mode version.
					$scope.projectToUpdate = null;
					$scope.import = true;
				} else {
					toaster.pop(
						'error',
						gettextCatalog.getString('project.bulk.execution.in.progress')
					);
				}
			});
		};

		$scope.importProjectVersion = function (version) {
			ProjectService.isAnyExecutionRunning().then(function (response) {
				if (!response.data) {
					$scope.import = true;
					$scope.projectToUpdate = version;
				} else {
					toaster.pop(
						'error',
						gettextCatalog.getString('project.bulk.execution.in.progress')
					);
				}
			});
		};

		$scope.deleteProject = function (project) {
			$scope.projectToDelete = project;
			$scope.confirmationText = 'SUPPRIMER ' + project.metadata.label;
			$scope.visibleDeletePopup = true;
		};

		$scope.confirmDelete = function () {
			if ($scope.confirmationText == $scope.userConfirmationText) {
				ProjectService.deleteProject($scope.projectToDelete.id).then(function (
					data
				) {
					$scope.visibleDeletePopup = false;
					toaster.pop(
						'success',
						gettextCatalog.getString('Succès'),
						gettextCatalog.getString('Suppression du Projet effectuée')
					);
					delete $scope.projectToDelete;
					loadProjects();
				});
			} else {
				toaster.pop(
					'error',
					gettextCatalog.getString(
						'Le message ne correspond pas au message attendu'
					)
				);
			}
		};

		$scope.cancelDelete = function () {
			$scope.visibleDeletePopup = false;
		};

		$scope.afterSetDefault = function (projectId, isDefault) {
			if (isDefault) {
				for (let p in $scope.projects) {
					$scope.projects[p].default_project =
						$scope.projects[p].id == projectId;
					context - container;
				}
			}
		};

		$scope.afterSetFavorite = function (projectId, isFavorite) {
			for (let p in $scope.projects) {
				if ($scope.projects[p].id == projectId) {
					$scope.projects[p].favorite_project = isFavorite;
				}
			}
			$scope.filterProjects();
		};

		$scope.$on('refresh_projects_list', function (event, data) {
			loadProjects();
		});

		$rootScope.$on('import_project_new_version', function (event, data) {
			$scope.importProjectVersion(data);
		});
	}
})();
